
export const viewportChanged = (canvas, map) => {
  if(!map || !map.hasOwnProperty('projectId')) return;
  let coords = canvas.viewportTransform;
  let viewport = { projectId: map.projectId, coords }
  localStorage.setItem('viewport', JSON.stringify(viewport))
}

// reset viewport is handled in mapping/components/StatusButtons
// we pass the resize function from Map since it's 2 lines